import { Autocomplete, Button, Checkbox, Dialog, DialogTitle, Tooltip, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { getDeletedClients, restoreBulkClient, restoreClient } from "api/services/clients/clients";
import { getClientCategories } from "api/services/client-categories";
import { getAllUsersInOrganzaition, getDeletedUsers, getUsersActiveAndInactive } from "api/services/users";
import Loader from "components/Loader";
import Table, { ColumnType } from "components/Table";
import { snack } from "components/toast";
import { useConfirm } from "context/ConfirmDialog";
import { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { ResType } from "types";
import { handleError } from "utils/handleError";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { exportDeletedClientsPageReport } from "api/services/reports";
import { useConfirmCancel } from "context/ConfirmDialogTwo";
import SearchContainer from "components/SearchContainer";
import { getCountryCode } from "validations/phoneNumbr";
import { useUserData } from "context/UserProfile";
import { usePermissions } from "context/PermissionsProvider";
import PermissionDenied from "components/PemissionDenied";
import { Permissions } from "data/permissons";
import { getCurrentFormattedDateTime, getTitle } from "utils";
import { SortDirection } from "data/constants";
import sortHandler from "components/Table/SortHandler";
import _ from "lodash";
import LoadingButton from "components/LoadingButton";
import { StyledTextField } from "views/taskview/Details/Fields";
import moment from "moment";
import excelIcon from "./../../assets/images/128px-Microsoft_Office_Excel_(2019–2025).svg.png";
import { primaryclient } from "assets";


function DeletedClients(state) {
  const confirm = useConfirm();
  const confirmCancel = useConfirmCancel()
  const queryClient = useQueryClient();
  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(10);
  const [clientsData, setClientData] = useState([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [selected, setSelected] = useState<any[]>([]);
  const [deleteClientOpen, setDeleteClientOpen] = useState(false);
  const [deleteBulkClientOpen, setDeleteBulkClientOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [sort, setSort] = useState<any>({});
  const [dataa, setDataa] = useState<any>({});
  const [bulkDataa, setBulkDataa] = useState<any>([]);
  const [activeInactiveDataa, setActiveInactiveDataa] = useState<any>([]);
  const { data: userData } = useUserData();
  const { permissions } = usePermissions();
  const [categoryDialogOpen, setCategoryDialogOpen] =
    useState(false);

  const [restoreClientData, setRestoreClientData] =
    useState<any>(null);

  const [selectedCategory, setSelectedCategory] =
    useState<any>(null);

  const [selectedSubCategory, setSelectedSubCategory] =
    useState<any>(null);
  const [bulkCategoryDialogOpen, setBulkCategoryDialogOpen] = useState(false);

  const [bulkRestoreClients, setBulkRestoreClients] = useState<any[]>([]);

  const [bulkRestoreMode, setBulkRestoreMode] = useState<
    "same" | "individual" | null
  >(null);

  const [individualMappings, setIndividualMappings] =
    useState<any[]>([]);

  const { data: categories } = useQuery(
    "client-categories",
    getClientCategories
  );

  const { data, isLoading }: ResType = useQuery(["deleted-clients", {
    limit: pageCount,
    offset: page * pageCount,
    search: search, sort,
  }], getDeletedClients, {
    onSuccess: (res) => {
      setClientData(res?.data[0]);
      setTotalCount(res?.data[1]);
    },
    onError: (err: any) => {
      if (!err?.error) {
        snack.error(`An error occurred while fetching deleted clients`);
      }
    }
  });

  const { data: activeAndInactiveUsers, isLoading: actInactUsers }: ResType = useQuery("users", getUsersActiveAndInactive, {
    onSuccess: (res) => {
      setActiveInactiveDataa(res?.data);
    },
    onError: (err: any) => {
      if (!err?.error) {
        snack.error(`An error occurred while fetching active and inactive users`);
      }
    }
  });


  const { data: deletedUsers, isLoading: deletedUsersLoading }: ResType = useQuery(["deleted-users"], getDeletedUsers, {
    onSuccess: (res) => {
    },
    onError: (err: any) => {
      if (!err?.error) {
        snack.error(`An error occurred while fetching deleted users`);
      }
    }
  });

  const { data: users, isLoading: userLoading }: ResType = useQuery(
    "users",
    getAllUsersInOrganzaition
  );

  const { mutate, isLoading: restoreLoading } = useMutation(restoreClient, {
    onSuccess: (res: any) => {
      if (res?.data?.successList?.length > 0) {
        res?.data?.successList?.forEach((item: any) => snack.success(item));
      }
      if (res?.data?.errorList?.length > 0) {
        res?.data?.errorList?.forEach((item: any) => snack.error(item));
      }
      setDeleteClientOpen(false);
      setDataa({});
      snack.success("Client Access Restored");
      queryClient.invalidateQueries("deleted-clients");
    },
    onError: (err: any) => {
      if (err && !err?.error) {
        snack.error(handleError(err));
      } else if (!err?.error) {
        snack.error(`An error occurred while restoring clients`);
      }
    },
  });

  const { mutate: bulkMutate, isLoading: restoreBulkLoading } = useMutation(restoreBulkClient, {
    onSuccess: (res: any) => {
      if (res?.data?.successList?.length > 0) {
        res?.data?.successList?.forEach((item: any) => snack.success(item));
      }
      if (res?.data?.errorList?.length > 0) {
        res?.data?.errorList?.forEach((item: any) => snack.error(item));
      }
      setDeleteBulkClientOpen(false);
      setBulkDataa({});
      setActiveInactiveDataa([]);
      setSelected([]);
      snack.success("Client Access Restored");
      queryClient.invalidateQueries("deleted-clients");
    },
    onError: (err: any) => {
      if (err && !err?.error) {
        snack.error(handleError(err));
      } else if (!err?.error) {
        snack.error(`An error occurred while restoring clients`);
      }
    },
  });

  // const handleRestore = (id: number) => {
  //   confirm({
  //     msg: "Are you sure you want to restore this client?",
  //     action: () => mutate(id),
  //   });

  // };


  useEffect(() => {
    setColumns(defaultColumns);
  }, [deletedUsersLoading]);

  const handleRestore = (client: any) => {
    const deletedIds =
      deletedUsers?.data?.[0]?.map(
        (item: any) => item?.id
      ) || [];

    const taskMembersIds =
      client?.clientManagers?.map(
        (item: any) => item?.id
      ) || [];

    const hasDeletedMember =
      deletedIds?.some((id: any) =>
        taskMembersIds?.includes(id)
      );

    // 1. Client Manager validation first
    if (
      hasDeletedMember ||
      !taskMembersIds.length
    ) {
      setDataa(client);
      setDeleteClientOpen(true);
      return;
    }

    // 2. Category validation next
    if (!client?.newCategory) {
      setRestoreClientData(client);
      setSelectedCategory(null);
      setSelectedSubCategory(null);
      setCategoryDialogOpen(true);
      return;
    }

    // 3. Sub Category validation only if required
    const fullCategory = (categories?.data || []).find((c: any) => c.id === client?.newCategory?.id) || client?.newCategory;
    if (
      fullCategory?.subCategories?.length > 0 &&
      !client?.newSubCategory
    ) {
      setRestoreClientData(client);
      setSelectedCategory(fullCategory);
      setSelectedSubCategory(null);
      setCategoryDialogOpen(true);
      return;
    }

    // 4. Normal restore
    const id = client.id;

    confirm({
      msg: "Are you sure you want to restore this client?",
      action: () => {
        confirmCancel({
          msg: "Do you also want to restore atom pro for this client?",
          action: (
            restoreAtomProClients: boolean
          ) => {
            mutate({
              id,
              restoreAtomProClients,
            });
          },
          executeOnCancel: true,
        });
      },
    });
  };

  const handleBulkRestore = () => {
    const deletedIds = deletedUsers?.data?.[0]?.map((item: any) => item?.id);
    let hasDeletedMember = 0;
    for (let i of selected) {
      const taskMembersIds = i?.clientManagers.map((item: any) => item?.id);
      hasDeletedMember = deletedIds?.some((id: any) => taskMembersIds?.includes(id)) ? hasDeletedMember + 1 : hasDeletedMember + 0;
    }
    const ids = selected.map(item => item.id);
    const invalidClients = selected.filter(
      (client: any) => {

        if (!client?.newCategory) {
          return true;
        }

        const category =
          (categories?.data || []).find((c: any) => c.id === client?.newCategory?.id) || client.newCategory;

        if (
          category?.subCategories?.length > 0 &&
          !client?.newSubCategory
        ) {
          return true;
        }

        return false;
      }
    );

    if (invalidClients.length) {
      setBulkRestoreClients(invalidClients);
      setBulkRestoreMode(null);
      setSelectedCategory(null);
      setSelectedSubCategory(null);
      setBulkCategoryDialogOpen(true);
      return;
    }
    setDeleteBulkClientOpen(true);
    setBulkDataa(selected);
    setActiveInactiveDataa(activeAndInactiveUsers?.data);
  };


  const { mutate: mutate1, isLoading: exportLoading } = useMutation(exportDeletedClientsPageReport, {
    onSuccess: (res: any) => {
      const arr = new Uint8Array(res.data?.data);
      const blob = new Blob([arr], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const file = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      const formattedDateTime = getCurrentFormattedDateTime();
      link.href = file;
      link.download = `ATOM - Deleted Clients ${formattedDateTime}.xlsx`;
      link.click();
      snack.success("Exported successfully");
    },
    onError: (err: any) => {
      snack.error(err);
      snack.error(handleError(err));
    },
  });
  const handleExport = () => {
    if (exportLoading) return;
    mutate1({
      ...state,
    });
  }

  const handleSearch = (e) => {
    setSearch(e);
    setPage(0);
  }

  const handleBulkSubmit = (event: any) => {
    event.preventDefault();
    const ids = selected.map(item => item.id);
    if (!activeInactiveDataa.length) {
      return snack.error("Please add atleast one Client Manager !")
    } else {
      confirm({
        msg: "Are you sure you want to restore the selected clients ?",
        action: () => {
          confirmCancel({
            msg: "Do you also want to restore atom pro for the selected clients ?",
            action: (restoreAtomProClients: boolean) => {
              bulkMutate({ ids, activeInactiveDataa, restoreAtomProClients });
            },
            executeOnCancel: true,
          });
        },
      });
    }
  }

  const handleSubmit = (event: any) => {
    event.preventDefault();
    const deletedIds = deletedUsers?.data?.[0]?.map((item: any) => item?.id);
    const taskMembersIds = dataa?.clientManagers.map((item: any) => item?.id);
    const hasDeletedMember = deletedIds?.some((id: any) => taskMembersIds?.includes(id));
    const id = dataa?.id;
    const clientManagers = dataa?.clientManagers;

    if (!dataa?.newCategory) {
      setDeleteClientOpen(false);
      setRestoreClientData(dataa);
      setSelectedCategory(null);
      setSelectedSubCategory(null);
      setCategoryDialogOpen(true);
      return;
    }
    const fullCategoryForDataa = (categories?.data || []).find((c: any) => c.id === dataa?.newCategory?.id) || dataa?.newCategory;
    if (
      fullCategoryForDataa?.subCategories?.length > 0 &&
      !dataa?.newSubCategory
    ) {
      setDeleteClientOpen(false);
      setRestoreClientData(dataa);
      setSelectedCategory(fullCategoryForDataa);
      setSelectedSubCategory(null);
      setCategoryDialogOpen(true);
      return;
    }

    if (hasDeletedMember) {
      snack.error("Deleted users are there in task members !");
    } else {
      if (!dataa.clientManagers.length) {
        return snack.error("Please add atleast one Client Manager !")
      } else {
        confirm({
          msg: "Are you sure you want to restore this client?",
          action: () => {
            confirmCancel({
              msg: "Do you also want to restore atom pro for this client?",
              action: (restoreAtomProClients: boolean) => {
                mutate({ id, restoreAtomProClients, clientManagers });
              },
              executeOnCancel: true,
            });
          },
        });
      }
    }
  }

  const defaultColumns: Array<ColumnType> = [
    {
      key: "clientId",
      title: "Client ID",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
    },
    {
      key: "gstNumber",
      title: "GSTIN / PAN",
      // sort: true,
      // active: false,
      // direction: SortDirection.ASC, default: true,
      render: (row: any) => <Typography>{row?.gstNumber ? row?.gstNumber : row?.panNumber ? row?.panNumber : ""}</Typography>
    },
    {
      key: "category",
      title: "Category",
      // sort: true,
      // active: false,
      // direction: SortDirection.ASC, default: true,

      render: (row: any) => <Typography>{row?.newCategory?.name || ""}</Typography>
    },
    {
      key: "subCategory",
      title: "Sub Category",
      render: (row: any) => <Typography>{row?.newSubCategory?.name || ""}</Typography>
    },
    {
      key: "displayName",
      title: "Display Name",
      sort: true,
      active: false,
      direction: SortDirection.ASC,
      default: true,
      render: (row: any) => (
        <Box display="flex" alignItems="center">
          <Typography variant="body2">
            {row?.displayName || "---"}
          </Typography>

          {row?.isPrimary === true && (
            <img
              src={primaryclient}
              width="22"
              style={{ marginLeft: "6px", marginBottom: "-2px" }}
              alt="primary"
            />
          )}
        </Box>
      ),
    },
    {
      key: "mobileNumber",
      title: "Mobile Number",
      render: (row: any) => <Typography>{`+${getCountryCode(row?.countryCode) || 91} ${row?.mobileNumber}`}</Typography>

    },
    {
      key: "email",
      title: "Email ID",
    },
    {
      key: "updatedAt",
      title: "Last Updated at",
      sort: true,
      active: false,
      direction: SortDirection.ASC,
      default: true,
      render: (row) => {
        return moment(row?.updatedAt).format("DD-MM-YYYY HH:mm ");
      },
    },
  ]

  if (userData?.role?.name === "Admin" || permissions.includes(Permissions.RESTORE_DELETED_CLIENTS)) {
    defaultColumns.push({
      key: "Action",
      title: "Action",
      render: (item: any) => {
        return (
          <Button
            size="small"
            variant="contained"
            color="secondary"
            onClick={() => handleRestore(item)}
          >
            Restore
          </Button>
        );
      },
    })
  }
  const [columns, setColumns] = useState(_.cloneDeep(defaultColumns));
  const handleSort = (v: any) => {
    sortHandler({
      key: v.key,
      columns,
      sortState: sort,
      setSortState: setSort,
      setColumns: setColumns,
    });
  };

  const handleDialogClode = () => {
    setDeleteClientOpen(false);
    setDataa({});
  }

  const handleBulkDialogClode = () => {
    setDeleteBulkClientOpen(false);
    setBulkDataa([]);
  }

  if (isLoading || userLoading || deletedUsersLoading || actInactUsers) return <Loader />;

  if (userData?.role?.name !== "Admin" && !permissions.includes(Permissions.VIEW_DELETED_CLIENTS)) {
    return (
      <PermissionDenied />
    );
  }

  return (
    <Box>
      <Box display="flex" gap={3} justifyContent="space-between" mt={2} mb={1} px={1}>
        <SearchContainer
          debounced
          value={search}
          minWidth="600px"
          placeHolder="Search by Client ID | Client Name | Mobile  | Email | GSTIN/PAN"
          onChange={handleSearch}
        />
        <Box display={"flex"}>

          {selected.length > 1 &&
            (userData?.role?.name === "Admin" || permissions.includes(Permissions.RESTORE_DELETED_CLIENTS)) && <Box><Button variant="outlined" color="secondary" sx={{ ml: 2 }} onClick={handleBulkRestore}>
              Restore
            </Button></Box>}
          <Button >
            <Button>
              <Tooltip title={exportLoading ? "Exporting..." : "Data Export to Excel"}>
                <img
                  src={excelIcon}
                  alt="Export"
                  style={{
                    cursor: exportLoading ? "not-allowed" : "pointer",
                    width: 35,
                    height: 35,
                    opacity: exportLoading ? 0.5 : 1,
                    marginTop: -10,
                    transition: "opacity 0.2s ease",
                  }}
                  onClick={handleExport}
                />
              </Tooltip>
            </Button>

          </Button>
        </Box>
      </Box>
      <Box px={1}>
        <Table
          sx={{ mb: 0, pb: 0, height: '520px' }}
          loading={isLoading}
          data={clientsData || []}
          columns={columns}
          sortHandler={handleSort}
          selection={{ selected, setSelected }}
          pagination={{ totalCount, page, setPage, pageCount, setPageCount }}
        />
      </Box>
      <Dialog maxWidth={"md"} open={deleteClientOpen} onClose={() => handleDialogClode()}>
        <DialogTitle>To Restore Update Deleted Client Managers</DialogTitle>
        <form onSubmit={(e) => handleSubmit(e)} style={{ padding: "20px" }}>
          <Autocomplete
            multiple
            disableCloseOnSelect
            options={[{ id: "selectAll", fullName: "Select All" }, ...(users?.data || [])]}
            getOptionLabel={(option) => option.fullName || ""}
            value={dataa?.clientManagers || []}
            onChange={(_, newSelected) => {
              const isAllSelected = dataa?.clientManagers?.length === users?.data?.length;

              if (newSelected.some((item) => item.id === "selectAll")) {
                setDataa({
                  ...dataa,
                  clientManagers: isAllSelected ? [] : users?.data || [],
                });
              } else {
                setDataa({ ...dataa, clientManagers: newSelected });
              }
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderOption={(props, option, { selected }) => {
              const isSelectAll = option.id === "selectAll";
              const isAllSelected = dataa?.clientManagers?.length === users?.data?.length;

              return (
                <li {...props} key={option.id} onClick={(e) => e.stopPropagation()}>
                  <Checkbox
                    checked={isSelectAll ? isAllSelected : (dataa?.clientManagers || []).some((o) => o.id === option.id)}
                    onChange={() => {
                      if (isSelectAll) {
                        setDataa({
                          ...dataa,
                          clientManagers: isAllSelected ? [] : users?.data || [],
                        });
                      } else {
                        const exists = (dataa?.clientManagers || []).some((o) => o.id === option.id);
                        const updatedList = exists
                          ? (dataa?.clientManagers || []).filter((o) => o.id !== option.id)
                          : [...(dataa?.clientManagers || []), option];

                        setDataa({
                          ...dataa,
                          clientManagers: updatedList,
                        });
                      }
                    }}
                    style={{ marginRight: 8 }}
                  />
                  {option.fullName}
                </li>
              );
            }}
            renderInput={(params) => (
              <StyledTextField
                {...params}
                label="Client Managers"
                variant="outlined"
                size="small"
                fullWidth
              />
            )}
          />

          <Box display="flex" justifyContent="flex-end" mt={2} gap={2}>
            <LoadingButton
              loading={restoreLoading}
              disabled={restoreLoading}
              fullWidth
              loadingColor="white"
              title="Update"
              color="secondary"
              type="submit"
            />
          </Box>
        </form>
      </Dialog>
      <Dialog maxWidth={"md"} open={deleteBulkClientOpen} onClose={() => handleBulkDialogClode()}>
        <DialogTitle>To Restore Selected Clients Update Client Managers</DialogTitle>
        <form onSubmit={(e) => handleBulkSubmit(e)} style={{ padding: "20px" }}>
          <Autocomplete
            multiple
            disableCloseOnSelect
            options={[{ id: "selectAll", fullName: "Select All" }, ...(activeAndInactiveUsers?.data || [])]}
            getOptionLabel={(option) => option.fullName || ""}
            value={activeInactiveDataa || []}
            onChange={(_, newSelected) => {
              const totalUsers = activeAndInactiveUsers?.data?.length || 0;
              const isAllSelected = activeInactiveDataa?.length === totalUsers;

              if (newSelected.some((item) => item.id === "selectAll")) {
                setActiveInactiveDataa(isAllSelected ? [] : activeAndInactiveUsers?.data || []);
              } else {
                setActiveInactiveDataa(newSelected);
              }
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderOption={(props, option, { selected }) => {
              const isSelectAll = option.id === "selectAll";
              const totalUsers = activeAndInactiveUsers?.data?.length || 0;
              const isAllSelected = activeInactiveDataa?.length === totalUsers;

              return (
                <li {...props} key={option.id} onClick={(e) => e.stopPropagation()}>
                  <Checkbox
                    checked={
                      isSelectAll
                        ? isAllSelected
                        : (activeInactiveDataa || []).some((o) => o.id === option.id)
                    }
                    onChange={() => {
                      if (isSelectAll) {
                        setActiveInactiveDataa(isAllSelected ? [] : activeAndInactiveUsers?.data || []);
                      } else {
                        const exists = (activeInactiveDataa || []).some((o) => o.id === option.id);
                        const updatedList = exists
                          ? (activeInactiveDataa || []).filter((o) => o.id !== option.id)
                          : [...(activeInactiveDataa || []), option];

                        setActiveInactiveDataa(updatedList);
                      }
                    }}
                    style={{ marginRight: 8 }}
                  />
                  {option.fullName}
                </li>
              );
            }}
            renderInput={(params) => (
              <StyledTextField
                {...params}
                label="Client Managers"
                variant="outlined"
                size="small"
                fullWidth
              />
            )}
          />
          <Box display="flex" justifyContent="flex-end" mt={2} gap={2}>
            <LoadingButton
              loading={restoreBulkLoading}
              disabled={restoreBulkLoading}
              fullWidth
              loadingColor="white"
              title="Update"
              color="secondary"
              type="submit"
            />
          </Box>
        </form>
      </Dialog>
      <Dialog
        open={categoryDialogOpen}
        onClose={() => setCategoryDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Category/Sub Category Missing
        </DialogTitle>

        <Box p={2}>
          <Autocomplete
            options={categories?.data || []}
            getOptionLabel={(option: any) =>
              option?.name || ""
            }
            value={selectedCategory}
            onChange={(_, value: any) => {
              setSelectedCategory(value);
              setSelectedSubCategory(null);
            }}
            renderInput={(params) => (
              <StyledTextField
                {...params}
                label="Category"
              />
            )}
          />

          <Box mt={2} />

          {selectedCategory?.subCategories?.length > 0 && (
            <>
              <Box mt={2} />

              <Autocomplete
                options={
                  selectedCategory.subCategories
                }
                getOptionLabel={(option: any) =>
                  option?.name || ""
                }
                value={selectedSubCategory}
                onChange={(_, value: any) =>
                  setSelectedSubCategory(value)
                }
                renderInput={(params) => (
                  <StyledTextField
                    {...params}
                    label="Sub Category"
                  />
                )}
              />
            </>
          )}

          <Box
            mt={2}
            display="flex"
            justifyContent="flex-end"
          >
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {

                if (!selectedCategory) {
                  snack.error(
                    "Please select category"
                  );
                  return;
                }

                if (
                  selectedCategory?.subCategories?.length > 0 &&
                  !selectedSubCategory
                ) {
                  return snack.error(
                    "Please select sub category"
                  );
                }

                confirm({
                  msg:
                    "Are you sure you want to restore this client?",
                  action: () => {

                    confirmCancel({
                      msg:
                        "Do you also want to restore atom pro for this client?",
                      action: (
                        restoreAtomProClients: boolean
                      ) => {

                        mutate({
                          id: restoreClientData.id,
                          restoreAtomProClients,

                          newCategoryId:
                            selectedCategory.id,

                          newSubCategoryId:
                            selectedSubCategory?.id || null,
                        });

                        setCategoryDialogOpen(false);
                      },
                      executeOnCancel: true,
                    });

                  },
                });

              }}
            >
              Restore
            </Button>
          </Box>
        </Box>
      </Dialog>
      <Dialog
        open={bulkCategoryDialogOpen}
        onClose={() => setBulkCategoryDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Bulk Category Assignment
        </DialogTitle>

        <Box p={2}>
          {bulkRestoreMode === null && (
            <>
              <Typography mb={2}>
                Some selected clients have missing Category/Sub Category.
              </Typography>

              <Button
                fullWidth
                variant="contained"
                color="secondary"
                onClick={() => setBulkRestoreMode("same")}
              >
                Assign Same Category To All
              </Button>

              <Box mt={2} />

              <Button
                fullWidth
                variant="outlined"
                color="secondary"
                onClick={() => {
                  setBulkRestoreMode("individual");

                  setIndividualMappings(
                    bulkRestoreClients.map((client: any) => ({
                      clientId: client.id,
                      displayName: client.displayName,
                      categoryId: client.newCategory?.id || null,
                      subCategoryId: client.newSubCategory?.id || null,
                    }))
                  );
                }}
              >
                Assign Individually
              </Button>
            </>
          )}

          {bulkRestoreMode === "same" && (
            <>
              <Autocomplete
                options={categories?.data || []}
                getOptionLabel={(o: any) => o?.name || ""}
                value={selectedCategory}
                onChange={(_, value: any) => {
                  setSelectedCategory(value);
                  setSelectedSubCategory(null);
                }}
                renderInput={(params) => (
                  <StyledTextField
                    {...params}
                    label="Category"
                  />
                )}
              />

              <Box mt={2} />

              {selectedCategory?.subCategories?.length > 0 && (
                <>
                  <Box mt={2} />

                  <Autocomplete
                    options={
                      selectedCategory.subCategories
                    }
                    getOptionLabel={(option: any) =>
                      option?.name || ""
                    }
                    value={selectedSubCategory}
                    onChange={(_, value: any) =>
                      setSelectedSubCategory(value)
                    }
                    renderInput={(params) => (
                      <StyledTextField
                        {...params}
                        label="Sub Category"
                      />
                    )}
                  />
                </>
              )}

              <Box mt={3}>
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  onClick={() => {

                    if (!selectedCategory) {
                      return snack.error(
                        "Please select category"
                      );
                    }

                    if (
                      selectedCategory?.subCategories?.length > 0 &&
                      !selectedSubCategory
                    ) {
                      snack.error(
                        "Please select sub category"
                      );
                      return;
                    }

                    const ids =
                      bulkRestoreClients.map(
                        (item: any) => item.id
                      );

                    bulkMutate({
                      ids,
                      activeInactiveDataa,
                      bulkCategoryUpdate: true,
                      newCategoryId:
                        selectedCategory.id,
                      newSubCategoryId:
                        selectedSubCategory?.id || null,
                    });

                    setBulkCategoryDialogOpen(false);
                  }}
                >
                  Restore All
                </Button>
              </Box>
            </>
          )}

          {bulkRestoreMode === "individual" && (
            <>
              {individualMappings.map(
                (item: any, index: number) => {

                  const categoriesList =
                    (categories?.data || []) as any[];

                  const category =
                    categoriesList.find(
                      (x: any) =>
                        x.id === item.categoryId
                    );

                  return (
                    <Box
                      key={item.clientId}
                      mb={3}
                    >
                      <Typography
                        fontWeight={600}
                        mb={1}
                      >
                        {item.displayName}
                      </Typography>

                      <Autocomplete
                        options={
                          categories?.data || []
                        }
                        getOptionLabel={(o: any) =>
                          o?.name || ""
                        }
                        value={
                          category || null
                        }
                        onChange={(_, value: any) => {

                          const copy = [
                            ...individualMappings,
                          ];

                          copy[index] = {
                            ...copy[index],
                            categoryId:
                              value?.id || null,
                            subCategoryId:
                              null,
                          };

                          setIndividualMappings(
                            copy
                          );
                        }}
                        renderInput={(params) => (
                          <StyledTextField
                            {...params}
                            label="Category"
                          />
                        )}
                      />

                      <Box mt={1} />
                      {category?.subCategories?.length > 0 && (
                        <Autocomplete
                          options={category.subCategories}
                          getOptionLabel={(o: any) =>
                            o?.name || ""
                          }
                          value={
                            category?.subCategories?.find(
                              (s: any) =>
                                s.id ===
                                item.subCategoryId
                            ) || null
                          }
                          onChange={(_, value: any) => {

                            const copy = [
                              ...individualMappings,
                            ];

                            copy[index] = {
                              ...copy[index],
                              subCategoryId:
                                value?.id || null,
                            };

                            setIndividualMappings(
                              copy
                            );
                          }}
                          renderInput={(params) => (
                            <StyledTextField
                              {...params}
                              label="Sub Category"
                            />
                          )}
                        />
                      )}
                    </Box>
                  );
                }
              )}

              <Button
                fullWidth
                variant="contained"
                color="secondary"
                onClick={() => {

                  const invalid =
                    individualMappings.some(
                      (x: any) => {

                        if (!x.categoryId) {
                          return true;
                        }

                        const categoriesList =
                          (categories?.data || []) as any[];

                        const category =
                          categoriesList.find(
                            (c: any) =>
                              c.id === x.categoryId
                          );

                        if (
                          category?.subCategories?.length > 0 &&
                          !x.subCategoryId
                        ) {
                          return true;
                        }

                        return false;
                      }
                    );

                  if (invalid) {
                    return snack.error(
                      "Please complete all required category selections"
                    );
                  }

                  const ids =
                    selected.map(
                      (item: any) => item.id
                    );

                  bulkMutate({
                    ids,
                    activeInactiveDataa,
                    bulkCategoryUpdate: false,
                    clientCategoryMappings:
                      individualMappings,
                  });

                  setBulkCategoryDialogOpen(false);
                }}
              >
                Restore Selected Clients
              </Button>
            </>
          )}

        </Box>
      </Dialog>
    </Box>
  );
}

export default DeletedClients;
